import { render, staticRenderFns } from "./wxjl.vue?vue&type=template&id=01937e52&scoped=true"
import script from "./wxjl.vue?vue&type=script&lang=js"
export * from "./wxjl.vue?vue&type=script&lang=js"
import style0 from "./wxjl.vue?vue&type=style&index=0&id=01937e52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01937e52",
  null
  
)

export default component.exports